import { getHTMLElementFromRoot } from '../utility/helper';
import logger from './logger';
import { sendDataLayerEventShoppingCart } from './analytics/send-data-layer-events-service';

export async function openContextualDrawer() {
  try {
    await customElements.whenDefined('phn-nd-contextual-drawer');
    const contextualDrawer = getHTMLElementFromRoot('phn-nd-contextual-drawer') as any;
    await contextualDrawer.openDrawer();
    sendDataLayerEventShoppingCart('mainmenu.shop.search', 'Shop search');
  } catch (error) {
    logger.error('open-contextual-drawer', error as Error);
  }
}

export async function openNavigationDrawer(initialRoutingKeys?: string) {
  try {
    await customElements.whenDefined('phn-nd-navigation-drawer-initiater');
    const navigationDrawer = getHTMLElementFromRoot('phn-nd-navigation-drawer-initiater') as any;
    await navigationDrawer.openDrawer(initialRoutingKeys);
  } catch (error) {
    logger.error('open-navigation-drawer', error as Error);
  }
}

export async function closeNavigationDrawer() {
  try {
    await customElements.whenDefined('phn-nd-navigation-drawer-initiater');
    const navigationDrawer = getHTMLElementFromRoot('phn-nd-navigation-drawer-initiater') as any;
    await navigationDrawer.closeDrawer();
  } catch (error) {
    logger.error('open-navigation-drawer', error as Error);
  }
}
